import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { IBlockProps } from '~/types/template'

import ThickIcon from './icons/ThickIcon'

const IconBlock = ({ className, color, onClick }: IBlockProps): ReactElement => {
  const classes = classNames('icon-block', className)

  return (
    <div className={classes} onClick={onClick}>
      <ThickIcon color={color} size={21} />
    </div>
  )
}

export default IconBlock
